(()=>{
 const all=(s,r=document)=>[...r.querySelectorAll(s)];const reduce=matchMedia('(prefers-reduced-motion: reduce)');const animate=()=>!reduce.matches&&document.body.dataset.motion!=='false';
 function feature(section,index){const tabs=all('[data-health-tab]',section);index=(index+tabs.length)%tabs.length;section.dataset.active=index;tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.parentElement.querySelector('.health-feature-description').hidden=i!==index;});all('.health-feature-panel',section).forEach((p,i)=>p.hidden=i!==index);section.querySelector('[data-feature-count]').textContent=`${index+1} / ${tabs.length}`;}
 function journey(section,index){all('[data-journey-scene]',section).forEach((p,i)=>p.hidden=i!==index);all('[data-journey-tab]',section).forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));section.dataset.active=index;}
 document.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;const f=b.closest('[data-health-features]');if(f){if(b.matches('[data-health-tab]'))feature(f,Number(b.dataset.healthTab));if(b.matches('[data-feature-next]'))feature(f,Number(f.dataset.active||0)+1);if(b.matches('[data-feature-prev]'))feature(f,Number(f.dataset.active||0)-1);}if(b.matches('[data-journey-tab]')){const s=b.closest('[data-health-journey]');s.dataset.manual='true';journey(s,Number(b.dataset.journeyTab));}});
 document.addEventListener('keydown',e=>{if(!e.target.matches('[data-health-tab]'))return;const f=e.target.closest('[data-health-features]');const tabs=all('[data-health-tab]',f);let i=tabs.indexOf(e.target);if(e.key==='ArrowDown'||e.key==='ArrowRight')i++;else if(e.key==='ArrowUp'||e.key==='ArrowLeft')i--;else if(e.key==='Home')i=0;else if(e.key==='End')i=tabs.length-1;else return;e.preventDefault();i=(i+tabs.length)%tabs.length;feature(f,i);tabs[i].focus();});
 let scheduled=false;function update(){scheduled=false;all('[data-health-journey]').forEach(s=>{if(!animate())return;const r=s.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;const n=all('[data-journey-scene]',s).length;const p=Math.max(0,Math.min(.999,-r.top/Math.max(1,r.height-innerHeight)));const i=Math.floor(p*n);if(s.dataset.manual==='true')return;if(Number(s.dataset.active||0)!==i)journey(s,i);s.style.setProperty('--journey-drift',String(p*n-i));});}function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(update);}}addEventListener('scroll',()=>{all('[data-health-journey]').forEach(s=>delete s.dataset.manual);schedule();},{passive:true});addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);schedule();
 all('.mega').forEach(d=>{d.addEventListener('toggle',()=>{if(d.open)all('.mega').filter(x=>x!==d).forEach(x=>x.open=false);});});document.addEventListener('click',e=>{if(!e.target.closest('.site-header'))all('.mega[open]').forEach(x=>x.open=false);});
})();

(() => {
  if (window.vyraRotationInitialized) return;
  window.vyraRotationInitialized = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const sections = new Map();
  const enabled = () => !reduced.matches && document.body.dataset.motion !== 'false';
  let frame = 0;
  function update() {
    frame = 0;
    if (!enabled()) return;
    const height = innerHeight;
    const measurements = [...sections].filter(([s]) => s.isConnected && s.dataset.visible === 'true').map(([s, state]) => ({ state, rect: s.getBoundingClientRect() }));
    measurements.forEach(({ state, rect }) => state.seek(Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height - height)))));
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    const state = sections.get(entry.target);
    if (!state) return;
    entry.target.dataset.visible = String(entry.isIntersecting);
    if (entry.isIntersecting) { state.load(state.active()); schedule(); }
    else state.active()?.pause();
  }), { rootMargin: '200px' });
  function init(scope = document) {
    scope.querySelectorAll('[data-ring-rotation]').forEach(section => {
      if (sections.has(section)) return;
      const controller = new AbortController(), options = { signal: controller.signal };
      const videos = [...section.querySelectorAll('video')];
      const range = section.querySelector('[data-rotation-range]');
      const active = () => section.querySelector('video:not([hidden])');
      const load = video => {
        if (!video) return;
        const source = video.querySelector('[data-src]');
        if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); video.load(); }
      };
      const apply = video => {
        if (video !== active() || video.readyState < 1 || video.seeking || !video.paused || !Number.isFinite(video.duration)) return;
        const target = Number(section.dataset.target || 0) * Math.max(0, video.duration - .04);
        if (Math.abs(video.currentTime - target) > .025) video.currentTime = target;
      };
      const seek = progress => {
        const video = active();
        if (!video) return;
        section.dataset.target = progress;
        const value = String(Math.round(progress * 100));
        if (range.value !== value) range.value = value;
        load(video); apply(video);
      };
      sections.set(section, { active, load, seek, controller, videos });
      videos.forEach(video => {
        video.addEventListener('loadedmetadata', () => apply(video), options);
        video.addEventListener('seeked', () => apply(video), options);
        video.addEventListener('ended', () => { section.querySelector('[data-rotation-play]').textContent = window.VyraText('Revoir la rotation'); }, options);
      });
      section.addEventListener('input', event => {
        if (event.target.matches('[data-rotation-range]')) { active().pause(); seek(Number(event.target.value) / 100); }
      }, options);
      section.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.matches('[data-rotation-finish]')) {
          videos.forEach(video => { video.pause(); video.hidden = video.dataset.rotationVideo !== button.dataset.rotationFinish; });
          section.querySelectorAll('[data-rotation-finish]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          seek(Number(section.dataset.target || 0));
        }
        if (button.matches('[data-rotation-play]')) {
          const video = active(); load(video);
          if (video.paused) { video.currentTime = 0; video.play().then(() => { button.textContent = window.VyraText('Mettre en pause'); }).catch(() => {}); }
          else { video.pause(); button.textContent = window.VyraText('Lire la rotation'); }
        }
      }, options);
      observer.observe(section);
    });
    schedule();
  }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  reduced.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, state] of sections) {
      if (!event.target.contains(section)) continue;
      observer.unobserve(section); state.controller.abort(); state.videos.forEach(video => video.pause()); sections.delete(section);
    }
  });
  init();
})();
